module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightCond.bbf0eaf.eot";